var map = {
	"./afghanistan.jpg": 7636,
	"./albania.jpg": 7774,
	"./algeria.jpg": 1399,
	"./andorra.jpg": 7713,
	"./angola.jpg": 9830,
	"./argentina.jpg": 1745,
	"./armenia.jpg": 8307,
	"./australia.png": 6312,
	"./austria.jpg": 3667,
	"./azerbaijan.jpg": 799,
	"./bahamas.jpg": 4453,
	"./bahrain.jpg": 8717,
	"./bangladesh.jpg": 2559,
	"./barbados.jpg": 3282,
	"./belarus.jpg": 8882,
	"./belgium.jpg": 8969,
	"./bhutan.jpg": 4476,
	"./bolivia.jpg": 2742,
	"./brazil.jpg": 5714,
	"./brunei.jpg": 6791,
	"./bulgaria.jpg": 5223,
	"./cambodia.jpg": 6734,
	"./canada.jpg": 9814,
	"./chile.jpg": 9213,
	"./china.png": 5507,
	"./colombia.jpg": 2546,
	"./costarica.jpg": 8813,
	"./croatia.jpg": 8265,
	"./cuba.jpg": 4823,
	"./czechia.jpg": 2197,
	"./denmark.jpg": 4256,
	"./egypt.jpg": 211,
	"./fiji.jpg": 5944,
	"./finland.jpg": 4622,
	"./france.png": 8173,
	"./germany.jpg": 6585,
	"./greece.jpg": 8389,
	"./hungary.jpg": 4724,
	"./iceland.jpg": 1080,
	"./india.png": 3223,
	"./indonesia.jpg": 988,
	"./iran.jpg": 232,
	"./iraq.jpg": 9123,
	"./ireland.jpg": 1655,
	"./israel.jpg": 7744,
	"./italy.jpg": 7319,
	"./jamaica.jpg": 7772,
	"./japan.png": 9938,
	"./jordan.jpg": 6490,
	"./kazakhstan.jpg": 8702,
	"./kenya.jpg": 582,
	"./kuwait.jpg": 4715,
	"./kyrgyzstan.jpg": 108,
	"./laos.jpg": 9915,
	"./latvia.jpg": 4049,
	"./lebanon.jpg": 4581,
	"./liechtenstein.jpg": 797,
	"./lithuania.jpg": 4471,
	"./luxembourg.jpg": 4500,
	"./madagascar.jpg": 6984,
	"./malaysia.jpg": 3149,
	"./maldives.jpg": 1719,
	"./mexico.jpg": 9969,
	"./moldova.jpg": 8982,
	"./monaco.jpg": 9165,
	"./mongolia.jpg": 3894,
	"./morocco.jpg": 6580,
	"./myanmar.jpg": 3459,
	"./nepal.jpg": 4796,
	"./netherlands.jpg": 7766,
	"./newzealand.jpg": 5981,
	"./northkorea.jpg": 8409,
	"./norway.jpg": 738,
	"./philippines.jpg": 4207,
	"./poland.jpg": 4224,
	"./portugal.jpg": 8962,
	"./qatar.jpg": 1425,
	"./romania.jpg": 747,
	"./russia.jpg": 5463,
	"./singapore.jpg": 8380,
	"./southafrica.jpg": 5604,
	"./southkorea.jpg": 1879,
	"./spain.jpg": 2657,
	"./srilanka.jpg": 9453,
	"./sweden.jpg": 8144,
	"./switzerland.jpg": 4629,
	"./taiwan.png": 7600,
	"./thailand.jpg": 7161,
	"./turkiye.jpg": 8125,
	"./uae.jpg": 4213,
	"./uk.jpg": 2860,
	"./ukraine.jpg": 1849,
	"./usa.png": 9275,
	"./vietnam.png": 8562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5671;